import React from "react";
import {  useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getBreakEntries } from "../../api/entryAPI";
import EntryTable from "../entries/EntryTable";
import Loader from "../Loader";

function PinnedConditions() {
    const {id} = useParams();
    const token = useSelector(state => state.user.token)
    const entries = useSelector(state => state.entries.entries)
    const loading = useSelector(state => state.entries.loading)
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(getBreakEntries({id, token}))
    }, [dispatch, id, token])

    return(
        <div>
            <h2>Pinned Conditions</h2>
            <p className='description m-3'>Here are the conditions you have pinned for this break</p>

            {!loading ? <div>
                {entries.map(entry => {
                    if (entry.pinned) {
                        return(
                            <EntryTable
                                key={entry._id}
                                entryID={entry._id}
                                breakID={entry.breakID}
                                date={entry.date}
                                startTime={entry.startTime}
                                endTime={entry.endTime}
                                buoyData={entry.buoyData}
                                notes={entry.notes}
                                pinned={entry.pinned}
                            />
                        )
                    } else {
                        return ""
                    }
                })}
            </div> : <Loader />}
        </div>
    )

}

export default PinnedConditions;